export default "__VITE_ASSET__D7416eVy__"